import React from 'react';

import DocumentEntry from './DocumentEntry.jsx';
import DocumentEntity from '../../../../../../shared/src/entity/DocumentEntity';

/**
 * Component that displays the documents table for a given date.
 */
const DatedDocumentsTable = ({ subCategory, documents }) => (
  <div className="encart-table-month">
    <div className="encart-table-intitule">
      <span className="sub-category">{subCategory}</span>
      <span className="keyword">Pour aller plus loin</span>
    </div>

    {
      documents.map(document => (
        <DocumentEntry
          key={document.id}
          document={document}
        />
      ))
    }
  </div>
);

DatedDocumentsTable.propTypes = {
  /*
   * The list containing the documents to display.
   */
  documents: React.PropTypes.arrayOf(
    React.PropTypes.shape(DocumentEntity.shape),
  ).isRequired,
  /**
   * The group header (month or sub-category)
   */
  subCategory: React.PropTypes.string,
};

export default DatedDocumentsTable;



// WEBPACK FOOTER //
// ./book/src/commons/components/document/table/DatedDocumentsTable.jsx